$(document).ready(function(){
	var targetElements = $('.parallax-scene').get();
	var scenes = [];
	for (var i = 0; i < targetElements.length; i++) {
	  scenes.push(new Parallax(targetElements[i], {
		  selector: '.layer'
	  }));
	}

});